/** @file The auto-rig panel's actions: one per analysis fn, with its argument fields and ghost overlays. */
import type { AutorigAction } from './autorigTypes';

/** Panel order; `fields` mirror api AUTORIG_FNS (pinned by autorigActions.test.ts); `pivots` follow area X1. */
export const AUTORIG_ACTIONS = [
  { fn: 'autoRig', group: 'rig', label: 'autorig.fn.autoRig', fields: [{ key: 'images', kind: 'images', required: false, label: 'autorig.arg.images' }], overlays: ['bones', 'names', 'mesh'], pivots: true },
  { fn: 'suggestSkeleton', group: 'skeleton', label: 'autorig.fn.suggestSkeleton', fields: [{ key: 'images', kind: 'images', required: false, label: 'autorig.arg.images' }], overlays: ['bones', 'names'], pivots: true },
  { fn: 'detectJoints', group: 'skeleton', label: 'autorig.fn.detectJoints', fields: [{ key: 'pairs', kind: 'pairs', required: false, label: 'autorig.arg.pairs' }], overlays: ['bones', 'names'], pivots: true },
  { fn: 'inferDrawOrder', group: 'skeleton', label: 'autorig.fn.inferDrawOrder', fields: [{ key: 'facing', kind: 'facing', required: false, label: 'autorig.arg.facing' }], overlays: [], pivots: false },
  { fn: 'suggestIk', group: 'skeleton', label: 'autorig.fn.suggestIk', fields: [], overlays: ['bones', 'names'], pivots: false },
  { fn: 'checkMirrorAsymmetry', group: 'skeleton', label: 'autorig.fn.checkMirrorAsymmetry', fields: [], overlays: [], pivots: false },
  {
    fn: 'autoMesh', group: 'parts', label: 'autorig.fn.autoMesh', overlays: ['mesh'], pivots: false,
    fields: [
      { key: 'attachment', kind: 'attachment', required: true, label: 'autorig.arg.attachment', filter: 'region' },
      { key: 'detail', kind: 'detail', required: false, label: 'autorig.arg.detail' },
      { key: 'jointHints', kind: 'bones', required: false, label: 'autorig.arg.jointHints' },
    ],
  },
  {
    fn: 'autoWeights', group: 'parts', label: 'autorig.fn.autoWeights', overlays: ['mesh', 'bones'], pivots: false,
    fields: [
      { key: 'attachment', kind: 'attachment', required: true, label: 'autorig.arg.attachment', filter: 'mesh' },
      { key: 'bones', kind: 'bones', required: false, label: 'autorig.arg.bones' },
      { key: 'method', kind: 'method', required: false, label: 'autorig.arg.method' },
    ],
  },
  { fn: 'suggestHandle', group: 'parts', label: 'autorig.fn.suggestHandle', fields: [{ key: 'attachment', kind: 'attachment', required: true, label: 'autorig.arg.attachment', filter: 'any' }], overlays: ['bones'], pivots: false },
  {
    fn: 'suggestGrip', group: 'parts', label: 'autorig.fn.suggestGrip', overlays: ['bones'], pivots: false,
    fields: [
      { key: 'bone', kind: 'bone', required: true, label: 'autorig.arg.bone' },
      { key: 'attachment', kind: 'attachment', required: true, label: 'autorig.arg.attachment', filter: 'any' },
    ],
  },
  {
    fn: 'walkCycle', group: 'animate', label: 'autorig.fn.walkCycle', overlays: [], pivots: false,
    fields: [
      { key: 'animation', kind: 'text', required: false, label: 'autorig.arg.animation' },
      { key: 'frames', kind: 'int', required: false, label: 'autorig.arg.frames', range: [8, 240] },
      { key: 'facing', kind: 'walkFacing', required: false, label: 'autorig.arg.facing' },
      { key: 'limbs', kind: 'limbs', required: false, label: 'autorig.arg.limbs' },
    ],
  },
] as const satisfies readonly AutorigAction[];
